<template>
  <v-container fill-height>
    <v-layout text-center row wrap justify-center>
      <v-flex xs10>
        <Title title="Route" subtitle="Gib hier deine Route an" />

        <v-select :items="plans" label="Kategorie" solo v-model="route.category"></v-select>
        <v-text-field
          label="Streckennummer"
          placeholder="Streckennummer"
          solo
          @change="updateRoute()"
          v-model="route.id"
        ></v-text-field>

        <span v-if="showLoading" class="loading-circle"></span>

        <div class="mt-8">
          <v-btn to="/confirm" color="green" dark large :disabled="disabled">Weiter</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Title from '@/components/Title'

export default {
  components: {
    Title
  },
  data: () => ({
    plans: ['EP', 'EP-Sa', 'EP-So', 'EP-Feiertag', 'FL'],
    route: {
      category: '',
      id: ''
    },
    disabled: true,
    showLoading: false
  }),
  methods: {
    updateRoute() {
      if (!this.route.category) {
        alert('Einsatzplan existiert nicht')
        this.route.id = ''
        this.disabled = true
        return false
      }

      this.showLoading = true

      fetch(`${process.env.VUE_APP_API_URI}/plans/${this.route.category}/${this.route.id}`, {
        headers: new Headers({
          Authorization:
            'Basic ' + btoa(`${process.env.VUE_APP_USER}:${process.env.VUE_APP_PASSWORD}`),
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      })
        .then(res => res.json())
        .then(res => {
          this.showLoading = false

          if (res.plan != null) {
            const plan = res.plan

            const route = {
              id: plan.number,
              category: plan.category,
              from: plan.start,
              to: plan.end
            }

            this.$store.commit('updateRoute', route)
            this.disabled = false
          } else {
            alert('Einsatzplan existiert nicht')
            this.route.id = ''
            this.disabled = true
          }
        })
    }
  }
}
</script>
